export function Responsive() {
  return (
    <div className="relative overflow-hidden bg-slate-900 pt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-0">
        <div className="grid items-center">
          <div className="max-w-3xl mx-auto text-center mt-12">
            <h2 className="mt-6 text-4xl md:text-7xl font-bold text-white font-hdg">
              Built to be completed on every device
            </h2>
            <p className="max-w-2xl mx-auto mt-6 text-lg lg:text-xl text-slate-300 font-hdg">
              Mobile, tablet, or desktop — every form is fast, responsive, and built for completion, so users can fill it out easily wherever they are.
            </p>
            <a
              className="inline-block mt-6 text-lg lg:text-xl text-blue-300 font-semibold font-hdg hover:underline"
              href="https://my.heyform.net/sign-up"
            >
              Create a form that works everywhere →
            </a>
          </div>

          <div className="h-auto mt-12">
            <div className="max-w-6xl overflow-hidden rounded-lg bg-[#F8B1E2] shadow-[0_24px_70px_rgba(15,23,42,0.24)] md:rounded-xl lg:rounded-2xl">
              <img
                className="block h-auto w-full"
                src="/static/responsive.webp"
                alt="Responsive forms"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
